<app-nav titulo="Comerciales" descripcion="Gestión de comerciales vinculados a usuarios de la plataforma.">
    <div class="comerciales">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="comerciales"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updatePage($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nuevo">
            <mat-icon matPrefix class="add-button-icon">add</mat-icon>
            <span class="add-button-label">Nuevo comercial</span>
        </button>
    </div>
</app-nav>

<ng-template #activoColumnTemplate let-row="row">
    <span [class]="row.activo ? 'status-badge active' : 'status-badge inactive'">
        {{ row.activo ? 'Activo' : 'Inactivo' }}
    </span>
</ng-template>

<ng-template #actionsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Editar" [routerLink]="'./' + row.id + '/editar'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Dar de baja" (click)="deleteComercial(row)" *ngIf="row.activo">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
